<div
  role="tab"
  [attr.aria-expanded]="dwActive"
  class="ant-collapse-header"
  (click)="clickHeader()">
  <i class="arrow" *ngIf="dwShowArrow"></i>
  <ng-container *ngIf="isHeaderString; else headerTemplate">{{ dwHeader }}</ng-container>
  <ng-template #headerTemplate>
    <ng-template [ngTemplateOutlet]="dwHeader"></ng-template>
  </ng-template>
</div>
<div
  class="ant-collapse-content"
  [class.ant-collapse-content-active]="dwActive"
  [@collapseState]="dwActive?'active':'inactive'">
  <div class="ant-collapse-content-box">
    <ng-content></ng-content>
  </div>
</div>